import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { device } from '../../../utils/constants';
import {
  LabBottomRule,
  labAos,
  labBodyMobile,
  labTitleMobile,
} from './labShared';

const Section = styled.section`
  color: #ffffff;
  font-family: Helvetica, Arial, sans-serif;
  box-sizing: border-box;
`;

const Inner = styled.div`
  max-width: 100%;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 7vw;

  @media ${device.mobile} {
    margin-bottom: clamp(2.5rem, 10vw, 4rem);
  }
`;

export const Title = styled.h2`
  margin: 6vw 0;
  margin-bottom: 8vw;
  font-family: 'Horizon';
  font-size: 3vw;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  line-height: 1.2;
  ${labTitleMobile}

  @media ${device.mobile} {
    font-size: 1.5em;
    margin-bottom: clamp(2rem, 8vw, 3rem);
  }
`;

const Body = styled.p`
  margin: 3vw 0 0;
  font-family: 'TelegrafLight';
  font-size: 1.4vw;
  line-height: 1.3;
  ${labBodyMobile}

  &:first-of-type {
    margin-top: clamp(2.25rem, 5vw, 3.25rem);
  }

  @media ${device.mobile} {
    margin-top: clamp(1.25rem, 4vw, 1.75rem);

    &:first-of-type {
      margin-top: clamp(1.5rem, 5vw, 2rem);
    }
  }
`;

const BottomBlock = styled.div`
  padding-top: clamp(3rem, 8vw, 5rem);
  padding-bottom: clamp(1.25rem, 3vw, 2rem);

  @media ${device.mobile} {
    padding-top: clamp(2rem, 6vw, 3rem);
  }
`;

const WhoWeAreLab = () => {
  const { t } = useTranslation();

  return (
    <Section aria-labelledby="lab-who-we-are-heading">
      <Inner>
        <Title id="lab-who-we-are-heading" {...labAos('fade-up')}>
          {t('lab.whoWeAre.title')}
        </Title>
        <Body {...labAos('fade-up', 120)}>{t('lab.whoWeAre.text1')}</Body>
        <Body {...labAos('fade-up', 220)}>{t('lab.whoWeAre.text2')}</Body>
        <Body {...labAos('fade-up', 320)}>{t('lab.whoWeAre.text3')}</Body>
      </Inner>
      <BottomBlock>
        <LabBottomRule aria-hidden />
      </BottomBlock>
    </Section>
  );
};

export default WhoWeAreLab;
